/**
 * TopReferers.js - Типы действий для добавления данных о топе источников
 * @module constants/TopReferers
 * */

export const SET_TOP_REFERERS = 'SET_TOP_REFERERS'



// WEBPACK FOOTER //
// ./src/constants/TopReferers.js